import RootStoreContext from '~/contexts/RootStoreContext';
import async from '~/utils/async';
import resolver from './AgentScannersLayout.resolver';
import AgentScannersLayout from './AgentScannersLayout';

export default async(resolver, { context: RootStoreContext })(
  AgentScannersLayout
);
